/*
  Notify me from the product card, on the grid.

  KC, 2026-09-04: "can we add a 'notify me' to this view so they can sign up for their size."
  The PDP already captures per size in snippets/dc-size-availability.liquid. This does the
  same job from the collection grid so nobody has to open the product to get on the list.

  Multi-select is real. Klaviyo's back-in-stock endpoint takes one variant per request, so
  picking three sizes sends three requests and creates three subscriptions, all landing in
  the same flow. Partial failures are reported honestly rather than swallowed.

  Deliberately standalone. It does not touch dc-size-availability.liquid, which is live and
  selling. It shares the localStorage key with the PDP, so a size signed up for on one
  surface shows as signed up on the other.
*/
(function () {
  if (window.dcCardNotifyReady) return;
  window.dcCardNotifyReady = true;

  var COMPANY_ID = 'SCezzc';
  var REVISION = '2026-07-15';
  var STORE_KEY = 'dc-bis-subscribed';

  function readSubscribed() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function markSubscribed(id) {
    try { var all = readSubscribed(); all[id] = 1; localStorage.setItem(STORE_KEY, JSON.stringify(all)); } catch (e) {}
  }

  var dialog, productEl, pickEl, sizesEl, emailEl, submitEl, msgEl;
  var sizes = [], selected = [];

  function build() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'dc-cn';
    dialog.innerHTML =
      '<div class="dc-cn__inner">' +
        '<button type="button" class="dc-cn__close" aria-label="Close">&times;</button>' +
        '<p class="dc-cn__product" data-product></p>' +
        '<h2 class="dc-cn__title">First in line</h2>' +
        '<p class="dc-cn__sub">We\'ll email you the moment it lands</p>' +
        '<p class="dc-cn__pick" data-pick hidden>Pick any sizes you want</p>' +
        '<div class="dc-cn__sizes" data-sizes></div>' +
        '<div class="dc-cn__row">' +
          '<label class="dc-cn__sr" for="dc-cn-email">Email address</label>' +
          '<input class="dc-cn__input" id="dc-cn-email" type="email" inputmode="email" autocomplete="email" placeholder="you@email.com">' +
          '<button type="button" class="dc-cn__submit">Put me on the list</button>' +
        '</div>' +
        '<p class="dc-cn__terms">By signing up you agree to receive email from Del Campo Golf. Unsubscribe anytime.</p>' +
        '<p class="dc-cn__msg" role="status" aria-live="polite"></p>' +
      '</div>';
    document.body.appendChild(dialog);

    productEl = dialog.querySelector('[data-product]');
    pickEl = dialog.querySelector('[data-pick]');
    sizesEl = dialog.querySelector('[data-sizes]');
    emailEl = dialog.querySelector('.dc-cn__input');
    submitEl = dialog.querySelector('.dc-cn__submit');
    msgEl = dialog.querySelector('.dc-cn__msg');

    dialog.querySelector('.dc-cn__close').addEventListener('click', close);
    dialog.addEventListener('click', function (e) { if (e.target === dialog) close(); });
    submitEl.addEventListener('click', send);
    emailEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); send(); }
    });
  }

  function setMessage(text, state) {
    msgEl.textContent = text || '';
    msgEl.classList.remove('is-error', 'is-ok');
    if (state) msgEl.classList.add(state);
  }

  function renderSizes() {
    sizesEl.innerHTML = '';
    // One gone size needs no picker. The pill that was pressed already decided it.
    if (sizes.length === 1) {
      pickEl.hidden = true;
      var only = document.createElement('p');
      only.className = 'dc-cn__only';
      only.textContent = sizes[0].label;
      sizesEl.appendChild(only);
      return;
    }
    pickEl.hidden = false;
    sizes.forEach(function (s) {
      var on = selected.indexOf(s.id) > -1;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dc-cn__size';
      b.textContent = s.label;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.addEventListener('click', function () {
        var i = selected.indexOf(s.id);
        if (i > -1) selected.splice(i, 1); else selected.push(s.id);
        b.setAttribute('aria-pressed', selected.indexOf(s.id) > -1 ? 'true' : 'false');
        setMessage('');
      });
      sizesEl.appendChild(b);
    });
  }

  function open(payload) {
    build();
    sizes = payload.sizes;
    selected = payload.preselect ? [payload.preselect] : (sizes.length === 1 ? [sizes[0].id] : []);
    productEl.textContent = payload.product;
    setMessage('');
    renderSizes();
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    setTimeout(function () { emailEl.focus(); }, 40);
  }

  function close() {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
  }

  function paint(variantId) {
    var nodes = document.querySelectorAll('[data-dc-card-notify][data-variant-id="' + variantId + '"]');
    Array.prototype.forEach.call(nodes, function (el) { el.classList.add('is-subscribed'); });
  }

  function subscribe(variantId) {
    return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=' + encodeURIComponent(COMPANY_ID), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: emailEl.value.trim() } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return variantId;
    });
  }

  function labelFor(id) {
    for (var i = 0; i < sizes.length; i++) if (sizes[i].id === id) return sizes[i].label;
    return id;
  }

  function list(items) {
    if (items.length === 1) return items[0];
    if (items.length === 2) return items[0] + ' and ' + items[1];
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }

  function send() {
    if (!selected.length) { setMessage('Pick at least one size.', 'is-error'); return; }
    var value = emailEl.value.trim();
    if (!value || value.indexOf('@') < 1 || value.indexOf('.') < 0) {
      setMessage('Check the email address and try again.', 'is-error');
      emailEl.focus();
      return;
    }

    submitEl.disabled = true;
    setMessage(selected.length > 1 ? 'Adding you to ' + selected.length + ' sizes...' : 'Adding you...');

    // One request per size. Settled, not all-or-nothing: if three go out and one fails,
    // the customer should be told the two that worked rather than the whole thing failing.
    var done = [], failed = [];
    var work = selected.map(function (id) {
      return subscribe(id).then(
        function () { done.push(id); },
        function () { failed.push(id); }
      );
    });

    Promise.all(work).then(function () {
      done.forEach(function (id) { markSubscribed(id); paint(id); });

      if (done.length && !failed.length) {
        setMessage("You're on the list for " + list(done.map(labelFor)) + '. Watch your inbox.', 'is-ok');
        emailEl.value = '';
        setTimeout(close, 2200);
      } else if (done.length && failed.length) {
        setMessage('Added ' + list(done.map(labelFor)) + '. ' + list(failed.map(labelFor)) + " didn't save, try again.", 'is-error');
        selected = failed.slice();
        renderSizes();
      } else {
        setMessage("That didn't save. Try again.", 'is-error');
      }
      submitEl.disabled = false;
    });
  }

  function sizesIn(card) {
    return Array.prototype.map.call(card.querySelectorAll('[data-dc-card-notify]'), function (el) {
      return { id: el.getAttribute('data-variant-id'), label: el.getAttribute('data-variant-title') };
    });
  }

  function trigger(el) {
    var card = el.closest('[data-dc-card-root]');
    if (!card) return;
    var all = sizesIn(card);
    if (!all.length) return;
    open({
      product: el.getAttribute('data-product-title') || '',
      sizes: all,
      preselect: el.hasAttribute('data-dc-card-notify') ? el.getAttribute('data-variant-id') : null
    });
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-dc-card-notify], [data-dc-card-notify-all]');
    if (!el) return;
    e.preventDefault();
    trigger(el);
  });

  // The pills are li elements with role="button", so they need their own key handling.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = e.target.closest && e.target.closest('[data-dc-card-notify], [data-dc-card-notify-all]');
    if (!el) return;
    e.preventDefault();
    trigger(el);
  });

  function repaint() {
    var subs = readSubscribed();
    Object.keys(subs).forEach(paint);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repaint);
  else repaint();
  document.addEventListener('shopify:section:load', repaint);
})();
